const LAZY_CONTROLLERS = {
  'load-more': () => import(/* webpackChunkName: "ctrl-load-more" */ '../controllers/load_more_controller'),
  'slider': () => import(/* webpackChunkName: "ctrl-slider" */ '../controllers/slider_controller'),
  'faq-collapse': () => import(/* webpackChunkName: "ctrl-faq-collapse" */ '../controllers/faq_collapse_controller'),
  'html-embed': () => import(/* webpackChunkName: "ctrl-html-embed" */ '../controllers/html_embed_controller'),
  'richtext': () => import(/* webpackChunkName: "ctrl-richtext" */ '../controllers/richtext_controller'),
  'sliders--clients-slider': () => import(/* webpackChunkName: "ctrl-clients-slider" */ '../../components/sliders/clients_slider_controller'),
  'sliders--benefits-slider': () => import(/* webpackChunkName: "ctrl-benefits-slider" */ '../../components/sliders/benefits_slider_controller'),
  'sliders--services-slider': () => import(/* webpackChunkName: "ctrl-services-slider" */ '../../components/sliders/services_slider_controller'),
  'sliders--review-slider': () => import(/* webpackChunkName: "ctrl-review-slider" */ '../../components/sliders/review_slider_controller'),
  'sliders--card-slider': () => import(/* webpackChunkName: "ctrl-card-slider" */ '../../components/sliders/card_slider_controller'),
  'contact-form-component--contact-form': () => import(/* webpackChunkName: "ctrl-contact-form" */ '../../components/contact_form_component/contact_form_controller'),
  'stories--content--component': () => import(/* webpackChunkName: "ctrl-stories-content" */ '../../components/stories/content/component_controller'),
  'home--stories': () => import(/* webpackChunkName: "ctrl-home-stories" */ '../../components/home/stories_controller'),
}

const registeredIdentifiers = new Set()

export function collectControllerIdentifiers() {
  const identifiers = new Set()

  document.querySelectorAll('[data-controller]').forEach((element) => {
    const value = element.getAttribute('data-controller')
    if (!value) return

    value.trim().split(/\s+/).forEach((identifier) => {
      if (identifier) identifiers.add(identifier)
    })
  })

  return [...identifiers]
}

export async function loadControllersForPage(application, eagerIdentifiers) {
  const identifiers = collectControllerIdentifiers()
  const toLoad = identifiers.filter(
    (identifier) => !eagerIdentifiers.has(identifier) && !registeredIdentifiers.has(identifier)
  )

  await Promise.all(
    toLoad.map(async (identifier) => {
      const loader = LAZY_CONTROLLERS[identifier]
      if (!loader) return

      const module = await loader()
      application.register(identifier, module.default)
      registeredIdentifiers.add(identifier)
    })
  )
}
